import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { IIdItem } from '~src/spacesPlatform/models/resourceParts';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';
import { ResetUserMfaVerifiers } from '~src/userSettings/serverApi/requests/ResetUserMfaVerifiers';
import { ResetUserMfaVerifiersPermitted } from '~src/userSettings/serverApi/requests/ResetUserMfaVerifiersPermitted';

interface ResetUsersMFADialogProps {
    users: ISiteUser[];
    permitted: boolean;
}

function ids(items: IIdItem[]) {
    return items.map(item => item.id);
}

function fetchInitialBodyProps(users: ISiteUser[]): Promise<ResetUsersMFADialogProps> {
    const request = new ResetUserMfaVerifiersPermitted(ids(users));
    return WebHttpClientWithErrorToastInstance.sendRequest(request).then(result => {
        return {
            users,
            permitted: result.permitted
        };
    });
}

function action(props: ResetUsersMFADialogProps): Promise<any> {
    const request = new ResetUserMfaVerifiers(ids(props.users));
    return WebHttpClient.sendRequest(request).then((result: IResult) => {
        if (result && result.errors && result.errors.length > 0) {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.resetMfaError() });
        } else {
            ToasterService.instance.pop({ type: ToastType.Info, text: Messages.resetMfaSuccess() });
        }
    });
}

function bodyComponent(props: ResetUsersMFADialogProps): JSX.Element {
    if (props.permitted) {
        return <div>{Messages.resetMfaDescription()}</div>;
    } else {
        return <div>{Messages.resetMfaNotPermittedDescription()}</div>;
    }
}

export function showResetUsersMFADialog(users: ISiteUser[]): Promise<any> {
    return fetchInitialBodyProps(users).then(initialBodyProps => {
        const dialogInstance = openReactActionDialog<ResetUsersMFADialogProps, any, any>({
            action,
            actionDisabled: props => !props.permitted,
            actionName: Messages.resetMfa(),
            bodyComponent,
            dialogWidth: TabDialogWidth.width375px,
            dismissDialogOnActionFailed: true,
            initialBodyProps,
            initialDialogState: undefined,
            isActionDelete: true,
            title: Messages.resetMfa(),
        });

        return dialogInstance.result;
    });
}
